import useRealtime from "../../lib/useRealtime";
import { Sparkles, Percent, IndianRupee } from "lucide-react";
import ScToolkitBack from "../../components/sc/ScToolkitBack";

const CUSTOMER_BADGE = { residential: "Home", commercial: "Business", housing_society: "Society", all: "All" };

export default function ScSchemes() {
  const { data: slabs = [], loading } = useRealtime("/sc/schemes");

  if (loading && !slabs?.length) return <div className="font-mono text-xs text-slate-400 mt-10 text-center">Loading…</div>;

  return (
    <div data-testid="sc-schemes">
      <ScToolkitBack />
      <div className="font-mono text-[9px] uppercase tracking-[0.25em] text-slate-500">Incentive schemes</div>
      <h1 className="text-2xl font-bold tracking-tight mt-1 text-slate-900">How you earn.</h1>
      <p className="text-xs text-slate-500 mt-1">Active incentive slabs based on installed-order value.</p>

      <div className="mt-5 space-y-3">
        {(slabs || []).map((s) => {
          const RateIcon = s.rate_type === "percentage" ? Percent : IndianRupee;
          return (
            <div
              key={s.id}
              className="bg-white border border-slate-200 p-4 rounded-2xl shadow-[0_2px_8px_rgba(15,23,42,0.04)] hover:border-emerald-300 transition-colors"
              data-testid={`sc-scheme-${s.id}`}
            >
              <div className="flex items-start justify-between gap-3">
                <div className="flex-1 min-w-0">
                  <div className="text-lg font-bold text-slate-900">{s.name}</div>
                  {s.description && <div className="text-[12px] text-slate-500 mt-1">{s.description}</div>}
                </div>
                <div className="text-right shrink-0 bg-amber-50 border border-amber-200 px-3 py-1.5 rounded-lg">
                  <div className="text-xl font-bold text-[#B45309] flex items-center gap-0.5">
                    <RateIcon className="w-4 h-4" />
                    {s.rate}{s.rate_type === "percentage" ? "%" : ""}
                  </div>
                </div>
              </div>

              <div className="mt-3 grid grid-cols-2 gap-3 text-[12px]">
                <div>
                  <div className="text-slate-400 text-[10px] uppercase tracking-widest font-mono">Order value</div>
                  <div className="text-slate-900 mt-0.5 font-medium">
                    ₹{Number(s.min_value || 0).toLocaleString("en-IN")}
                    {s.max_value > 0 ? ` – ₹${Number(s.max_value).toLocaleString("en-IN")}` : "+"}
                  </div>
                </div>
                <div>
                  <div className="text-slate-400 text-[10px] uppercase tracking-widest font-mono">Customer</div>
                  <div className="text-slate-900 mt-0.5 font-medium">{CUSTOMER_BADGE[s.applicable_customer_type || "all"]}</div>
                </div>
              </div>
            </div>
          );
        })}
        {(!slabs || slabs.length === 0) && (
          <div className="text-center py-12 bg-white border border-slate-200 rounded-2xl">
            <Sparkles className="w-8 h-8 mx-auto text-slate-300" />
            <div className="font-mono text-xs text-slate-400 mt-3">No active schemes yet. Stay tuned — admin will publish them shortly.</div>
          </div>
        )}
      </div>
    </div>
  );
}
